import { render, staticRenderFns } from "./VipLevels.vue?vue&type=template&id=aa53a666&scoped=true"
import script from "./VipLevels.vue?vue&type=script&lang=js"
export * from "./VipLevels.vue?vue&type=script&lang=js"
import style0 from "./VipLevels.vue?vue&type=style&index=0&id=aa53a666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa53a666",
  null
  
)

export default component.exports